// Rechazos de la firma ligados al IMEI del equipo financiado, que va impreso en el contrato.
import { ApiError } from '@/api/errors';

export const FINANCED_IMEI_NOT_PINNED_MESSAGE =
    'Guarda el IMEI del equipo antes de mandar el código.';

/** `send-otp` rechazó porque el IMEI del equipo no está guardado en la venta. */
export function isFinancedImeiNotPinned(error: unknown): boolean {
    return error instanceof ApiError && error.code === 'FINANCED_IMEI_NOT_PINNED';
}
